import Entity from "./Entity";
import Search from "./Search";

const Body = () => {
    return (
        <div>
            <Search />
            <Entity />
        </div>
    );
}

export default Body;